import { render, staticRenderFns } from "./DialogTiptap.vue?vue&type=template&id=63a41c8c&"
import script from "./DialogTiptap.vue?vue&type=script&lang=js&"
export * from "./DialogTiptap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports